import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import Home from "../src/components/new/Home";
import SignIn from "./pages/Auth/SignIn";
import Main from "./components/layout/Main";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import "./assets/styles/bootstrap.scss";
import LayoutAlt from "./components/layout2/Main";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import mixpanel from "mixpanel-browser";
import Page404 from "./pages/404";
import Users from "./components/new/users";
import Entities from "./pages/Entities";
import { login } from "./store/action/user";
import ChangePassword from "./pages/Auth/ChangePassword";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import Financialyears from "./pages/financial_years";
import { useGetAllCompanies, useGetUser } from "./utils/queryUtils";
import Query from "./pages/Query";
import AllQueries from "./pages/AllQueries";
import Documents from "./pages/Documents";
import Help from "./pages/Help";
import Invite from "./pages/Invite";
import { getIdFromToken } from "./utils/jwtUtils";
import { setSelectedClient, setSelectedCompany, setSelectedFY, setSelectedPrimaryClient } from "./store/action/selected";
import { checkPath, normalizeString } from "./utils/pathUtils";
import Terms from "./pages/terms";
import Privacy from "./pages/privacy";
import ReloadTracker from "./components/ReloadTracker";
import { Alert, ConfigProvider } from "antd";
import useFetch from "./_fetch.js";
import { user_role } from "./consts.js";
import { roleThemes } from "./themeConfig.js";
import DrivePage from "./pages/Drive.js";
import FirmManagement from "./components/new/Firm.js";
import FirmUsers from "./components/new/FirmUsers.js";
import axios from "axios";

mixpanel.init("4a0b00365d809c96957f6c8086de8071", {
  debug: true,
});

function LayoutWrapper({ children }) {
  let { email } = useSelector((st) => st.user);
  if (!email) return <Navigate to="/auth/sign-in" />;
  return <Main>{children}</Main>;
}

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userChange, setUserChange] = useState();
  const [userId, setUserId] = useState(null);
  const userData = useSelector((st) => st.user);
  const { _id } = useSelector((st) => st.user);
  const { company = {} } = useSelector((st) => st.selected || {});
  const selectedClient = useSelector((st) => st.selected?.primaryClient);
  const selectedCompany = company?.name;
  const { data: all } = useGetAllCompanies();
  const location = useLocation();
  const [info, setInfo] = useState(false);
  const [mac, setMac] = useState();
  let { role } = useSelector((st) => st.user);
  const platform = window.navigator.platform;
  const macosPlatforms = ["macOS", "Macintosh", "MacIntel", "MacPPC", "Mac68K"];

  const Version = process.env.REACT_APP_FRONTEND_VERSION;

  useEffect(() => {
    const fetchUserId = async () => {
      try {
        const id = await getIdFromToken();
        setUserId(id);
      } catch (error) {
        if (
          location.pathname !== "/auth/forgot-password" &&
          !location.pathname.startsWith("/invite")
        ) {
          navigate("/auth/sign-in");
          console.error("Error fetching user ID:", error);
        }
      }
    };
    fetchUserId();
  }, [navigate]);

  useEffect(() => {

    async function platformCheck() {
      try {
        const { data: res } = await axios.get(`${process.env.REACT_APP_API_URL}/platformCheck`, {
          withCredentials: true,
          headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' },
        });

        const lastReload = localStorage.getItem("version_sync_reload");
        const currentTime = Date.now();
        const timeFromLastReload = currentTime - (lastReload || 0);
        const minutes = timeFromLastReload / 60000;

        // If version changed and more than 30 mins passed, reload
        if (res?.version !== Version && (minutes >= 30 || !lastReload)) {
          window.location.reload(true);
          localStorage.setItem("version_sync_reload", Date.now());
        }

        // Show version mismatch info
        if (res?.version !== Version) {
          setInfo(true);
        }

        // macOS detection
        if (macosPlatforms.includes(platform)) {
          setMac(true);
        }

      } catch (error) {
        console.error("Platform check failed:", error.message || error);
      }
    }

    platformCheck();

    const assignPath = async () => {
      const res = await checkPath();

      if (res === null) return;

      if (res?.success === false) {
        let companyExist = await checkPath(["", selectedCompany]);
        if (companyExist?.success === false) {
          localStorage.clear();
          dispatch(setSelectedCompany({}));
          navigate("/auth/sign-in");
          return;
        } else {
          navigate("/");
          return;
        }
      }
      if (res?.status === 200) {
        dispatch(setSelectedCompany(res.company));
        dispatch(setSelectedClient(res.client));
        dispatch(setSelectedFY(res.financialYear));
        dispatch(setSelectedPrimaryClient(res.primaryClient));
        if (
          role === user_role.PRIMARY_CLIENT &&
          userData.primary_client_first_logged_in === true
        ) {
          navigate(`/auth/change-password`);
        }
      }
    };
    assignPath();
  }, [navigate, dispatch]);

  useEffect(() => {
    if (all && all.length > 0) {
      if (!selectedCompany) {
        dispatch(setSelectedCompany(all[0]));
        navigate(`/${normalizeString(all[0].name)}`);
      }
    }
  }, [all, selectedCompany, dispatch, navigate]);
  const getBasePath = () => {
    if (selectedClient?._id) {
      return `/:companyName/${selectedClient._id}`;
    }
    return "/:companyName";
  };
  const LoginuserCache = useGetUser(userId);
  const data = LoginuserCache?.data;
  useEffect(() => {
    if (data && data.status === 200) {
      dispatch(login(data.response));
    }
  }, [data, dispatch]);

  return (
    <ConfigProvider
      theme={
        selectedClient?._id
          ? roleThemes?.PRIMARY_CLIENT
          : roleThemes.DEFAULT
      }
    >
      <React.Fragment>
        <div className="App">
          <ReloadTracker />
          {info ? (
            <Alert
              style={{
                display: "flex",
                alignItems: "center",
                textAlign: "center",
                fontWeight: "600",
                padding: "2px",
                fontSize: "10px",
              }}
              description={
                mac
                  ? "Efiles is not on the latest version, please Hard Reload by pressing Cmd + Shift + R "
                  : "Efiles is not on the latest version, please Hard Reload by pressing Ctrl + Shift + R"
              }
              type="error"
            />
          ) : (
            ""
          )}
          <Routes>
            {/* Auth */}
            <Route
              path="/auth/sign-in"
              element={
                <LayoutAlt userChange={userChange}>
                  <GoogleReCaptchaProvider
                    reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITEKEY}
                  >
                    <SignIn setUserChange={setUserChange} />
                  </GoogleReCaptchaProvider>
                </LayoutAlt>
              }
            />
            <Route path="/invite/:domain" element={<Invite />} />
            <Route
              path="/dashboard"
              element={<Navigate to={`/${normalizeString(selectedCompany)}`} replace />}
            />
            <Route
              path="/"
              element={<Navigate to={`/${normalizeString(selectedCompany)}`} replace />}
            />

            {/* Base company route */}
            <Route
              path={getBasePath()}
              element={
                <LayoutWrapper>
                  <Home />
                </LayoutWrapper>
              }
            />

            {/* Entities */}
            <Route
              path={`${getBasePath()}/entities`}
              element={
                <LayoutWrapper>
                  <Entities />
                </LayoutWrapper>
              }
            />

            {/* Financial years */}
            <Route
              path={`${getBasePath()}/:clientName`}
              element={
                <LayoutWrapper>
                  <Financialyears />
                </LayoutWrapper>
              }
            />

            {/* Drive */}
            <Route
              path={`${getBasePath()}/drive`}
              element={
                <LayoutWrapper>
                  <DrivePage />
                </LayoutWrapper>
              }
            />

            {/* All queries */}
            <Route
              path={`${getBasePath()}/:clientName/:fy`}
              element={
                <LayoutWrapper>
                  <AllQueries />
                </LayoutWrapper>
              }
            />

            {/* Query detail */}
            <Route
              path={`${getBasePath()}/:clientName/:fy/:queryId`}
              element={
                <LayoutWrapper>
                  <Query />
                </LayoutWrapper>
              }
            />

            {/* Documents */}
            <Route
              path={`${getBasePath()}/:clientName/:fy/:folderId`}
              element={
                <LayoutWrapper>
                  <Documents />
                </LayoutWrapper>
              }
            />

            {/* Users (restricted) */}
            {(role === user_role.ADMIN ||
              role === user_role.STAFF ||
              (role === user_role.ACCOUNTANT &&
                (userData?.can_invite_accountant ||
                  userData?.can_invite_staff))) && (
                <Route
                  path="/users"
                  element={
                    <LayoutWrapper>
                      <Users />
                    </LayoutWrapper>
                  }
                />
              )}

            {role === user_role.ADMIN &&

              <Route
                exact
                path="/firms"
                element={
                  <LayoutWrapper>
                    <FirmManagement />
                  </LayoutWrapper>
                }
              />
            }
            {role === user_role.ADMIN &&
              <Route
                exact
                path="/:name/users"
                element={
                  <LayoutWrapper>
                    <FirmUsers />
                  </LayoutWrapper>
                }
              />
            }


            <Route
              path="/help-center"
              element={
                <LayoutWrapper>
                  <Help />
                </LayoutWrapper>
              }
            />

            <Route
              path="/auth/change-password"
              element={
                <LayoutWrapper>
                  <ChangePassword />
                </LayoutWrapper>
              }
            />
            <Route path="/auth/forgot-password" element={<ForgotPassword />} />
            <Route
              path="/privacy"
              element={
                _id ? (
                  <LayoutWrapper>
                    <Privacy />
                  </LayoutWrapper>
                ) : (
                  <LayoutAlt>
                    <Privacy />
                  </LayoutAlt>
                )
              }
            />
            <Route
              path="/termsandcondition"
              element={
                <LayoutWrapper>
                  <Terms />
                </LayoutWrapper>
              }
            />

            {/* 404 */}
            <Route path="*" element={<Page404 />} />
          </Routes>
        </div>
      </React.Fragment>
    </ConfigProvider>
  );
}

export default App;
